import React,{ useState, useEffect } from 'react'
import Header from '../../layouts/Header'
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
import { Button, Card, Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { useSelector } from 'react-redux';

const Level = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [levelAccess, setLevelAccess] = useState([]);
    
    console.log("Access :", access);
    
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("Level:")
            );
            setLevelAccess(filteredAccess);
        } 
    }, [access]);
    
    console.log("Menu Access:", levelAccess);

    const accessToken = localStorage.getItem("authToken");
    const [levels, setLevels] = useState([]);
    const [addNewOpenModal, setAddNewOpenModal] = useState(false);
    const [inputData, setInputData] = useState({
        title: "",
        sequenceNo: "",
        pointsEarningPercent: "",
        boosterPercent: "",
        requiredPoints: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [bannerImage, setBannerImage] = useState(null);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [levelId, setLevelId] = useState('');
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);

    const getLevels = async () => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axiosInstance.get("level", { headers });
          if (response?.data?.status === true) {
            const levels = response?.data?.data?.levels;
            setLevels(levels);
            console.log("levels :", levels);
            
          }
        } catch (error) {
          if (error?.response && error?.response?.data?.status === false) {
            let errorMessage = error?.response?.data?.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const handleOpenAddModal = () => {
        setAddNewOpenModal(true);
    };

    const handleCloseAddModal = () => {
        setAddNewOpenModal(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
    
        let sanitizedValue = value;
    
        const isPositiveInteger = (val) => {
          const num = Number(val);
          return Number.isInteger(num) && num >= 0;
        };
    
        if (name === "pointsEarningPercent" || name === "boosterPercent" || name === "requiredPoints") {
          if (isPositiveInteger(value)) {
            sanitizedValue = value;
          } else {
            sanitizedValue = "";
          }
        }
    
        if (name === "title") {
          sanitizedValue = value;
        }
    
        setInputData((prev) => ({ ...prev, [name]: sanitizedValue }));
    };

    const handleBannerImageChange = () => {
        const input = document.getElementById("imageInput");
    
        const file = input.files[0];
    
        if (file) {
          const reader = new FileReader();
    
          reader.onloadend = () => {
            const image = new Image();
            image.src = reader.result;
    
            image.onload = () => {
              const width = image.width;
              const height = image.height;
    
              const maxWidth = 1920;
              const maxHeight = 1080;
    
              if (width === maxWidth && height === maxHeight) {
                setBannerImage(file);
              } else {
                alert(
                  "Image dimensions are not valid. Please choose an image with dimensions equal to " +
                  maxWidth +
                  "x" +
                  maxHeight
                );
                input.value = "";
              }
            };
          };
          reader.readAsDataURL(file);
        }
    };

    const addLevel = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
          const formData = new FormData();
          formData.append("title", inputData.title);
          formData.append("sequenceNo", inputData.sequenceNo);
          formData.append("pointsEarningPercent", inputData.pointsEarningPercent);
          formData.append("requiredPoints", inputData?.requiredPoints)
          formData.append("bannerImage", bannerImage);
    
          if (inputData?.boosterPercent !== "") {
            formData.append("boosterPercent", inputData?.boosterPercent);
          }
          const headers = {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          };
    
          const response = await axiosInstance.post("level", formData, { headers });
    
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
    
            e.target.reset();
            getLevels();
            setInputData({
              title: "",
              sequenceNo: "",
              pointsEarningPercent: "",
            });
            setBannerImage(null)
            setAddNewOpenModal(false);
          }
        } catch (error) {
          if (error?.response) {
            let errorMessage = '';
            if (
              error.response?.status === 406
            ) {
              errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if (
              error.response?.status === 412
            ) {
              errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
              errorMessage = error?.response?.data?.error
            }
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsLoading(false);
        }
    };

    const handleOpenEditModal = (data) => {
        setEditedData({
            _id: data?._id,
            title: data?.title,
            sequenceNo: data?.sequenceNo,
            pointsEarningPercent: data?.pointsEarningPercent,
            boosterPercent: data?.boosterPercent,
            requiredPoints: data?.requiredPoints
        });
        setOpenEditModal(true);
    }

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
    }

    const handleEditChange = (e) => {
        const { name, value } = e.target;
    
        let sanitizedValue = value;
    
        const isPositiveInteger = (val) => {
          const num = Number(val);
          return Number.isInteger(num) && num >= 0;
        };
    
        if (name === "pointsEarningPercent" || name === "boosterPercent" || name === "requiredPoints") {
          if (isPositiveInteger(value)) {
            sanitizedValue = value;
          } else {
            sanitizedValue = "";
          }
        }
    
        if (name === "title") {
          sanitizedValue = value
        }
    
        setEditedData((prev) => ({ ...prev, [name]: sanitizedValue }));
    }

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
          const formData = new FormData();
          formData.append("_id", editedData?._id)
          formData.append("title", editedData.title);
          formData.append("sequenceNo", editedData.sequenceNo);
          formData.append("pointsEarningPercent", editedData.pointsEarningPercent);
          formData.append("requiredPoints", editedData?.requiredPoints);
          if (editedData?.boosterPercent !== "") {
            formData.append("boosterPercent", editedData?.boosterPercent);
          }
    
          const headers = {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          };
    
          const response = await axiosInstance.put("level", formData, { headers });
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getLevels()
            setOpenEditModal(false);
          }
        } catch (error) {
          if (error?.response) {
            let errorMessage = '';
            if (
              error.response?.status === 406
            ) {
              errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if (
              error.response?.status === 412
            ) {
              errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
              errorMessage = error?.response?.data?.error
            }
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsEditBtnLoading(false);
        }
    };

    const handleOpenDeleteModal = (data) => {
        setLevelId(data?._id);
        setOpenDeleteModal(true);
    }

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    }

    const handleDeleteLevel = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
    
          const data = {
            _id: levelId,
          };
    
          const response = await axiosInstance.delete(`level`, { data, headers });
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getLevels();
            setOpenDeleteModal(false);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsDeleteBtnLoading(false);
        }
    };

    useEffect(() => {
        getLevels()
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className='main main-app p-3 p-lg-4'>
                {/* <div className="mb-4 text-end">
                    <Button
                        variant="primary"
                        onClick={handleOpenAddModal}
                        className="fw-semibold"
                    >
                        <i className="ri-add-line" style={{ marginRight: '5px' }}></i>
                        Add New Level
                    </Button>
                </div> */}

                {/* <Row>
                    {levels.map((level, index) => (
                        <Col sm={4} md={3} key={index} className="mb-4">
                            <Card className="shadow-sm rounded-4 custom-card">
                                <Card.Img variant="top" src={level?.bannerImage} alt={level?.title} className="rounded-top"/>
                                <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <Card.Title className="text-primary font-weight-bold mt-1">{level.title}</Card.Title>
                                        <span className="badge fw-bold bg-info text-white">{level?.sequenceNo}</span>
                                    </div>
                                    <Card.Text className="text-muted">
                                        <div className="mb-2">
                                            <span className='fw-semibold'>Required Points :</span>
                                            <span className="text-success fw-bold ms-2">{level.requiredPoints}</span>
                                        </div>
                                        <div className="mb-2">
                                            <span className='fw-semibold'>Point Earning % :</span>
                                            <span className="text-warning fw-bold ms-2">{level.pointsEarningPercent}%</span>
                                        </div>
                                    </Card.Text>
                                    <div className="d-flex justify-content-between">
                                        <Button variant="primary" size="sm" className="d-flex align-items-center" onClick={() => handleOpenEditModal(level)}>Edit
                                        </Button>
                                        <Button variant="danger" size="sm" className="d-flex align-items-center" onClick={() => handleOpenDeleteModal(level)}>Delete
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row> */}
                
                <div
                  className="container shadow-sm"
                  style={{ backgroundColor: "white" }}
                >
                  <Row className="pt-4">
                    <Col>
                        <h5 className="fw-semibold">LEVELS</h5>
                    </Col>
                    <hr />
                  </Row>

                  <Row className='mb-3'>
                    <Col className='text-end'>
                      {(levelAccess.includes("Level:add") || email === "contact@xpansecafe.com") && (
                        <Button
                            variant="primary"
                            onClick={handleOpenAddModal}
                            className="fw-semibold"
                        >
                            <i className="ri-add-line" style={{ marginRight: '5px' }}></i>
                            Add New Level
                        </Button>
                      )}
                    </Col>
                  </Row>

                  <Row>
                      <Table striped bordered hover responsive>
                              <thead>
                                  <tr>
                                      <th>Seq No</th>
                                      <th>Banner Image</th>
                                      <th>Title</th>
                                      <th>Required Points</th>
                                      <th>Points Earning %</th>
                                      {((levelAccess.includes("Level:update") || levelAccess.includes("Level:delete")) || email === "contact@xpansecafe.com") && (
                                        <th>Action</th>
                                      )}
                                  </tr>
                              </thead>
                              <tbody>
                                  { levels?.map((level, index) => ( 
                                          <tr className='align-items-center' style={{ verticalAlign: 'middle' }}>
                                              <td className='text-center'>{level?.sequenceNo}</td>
                                              <td className='align-items-center' style={{ width: '200px' }}>
                                                  <img
                                                      src={level?.bannerImage}
                                                      alt="Banner"
                                                      className="img-fluid"
                                                      style={{
                                                          width: "100%",
                                                          height: "50%",
                                                          marginTop: "8px",
                                                          marginBottom: '8px',
                                                          border: "0.2px solid bluevoilet",
                                                          cursor: "pointer",
                                                          // marginRight: 
                                                      }}
                                                      // onClick={() => handleBannerImageClick(level)}
                                                  />
                                              </td>
                                              <td className='text-primary fw-semibold'>{level?.title}</td>
                                              <td className='text-center'>{level?.requiredPoints}</td>
                                              <td className='text-center'>{level?.pointsEarningPercent}</td>
                                              {((levelAccess.includes("Level:update") || levelAccess.includes("Level:delete")) || email === "contact@xpansecafe.com") && (
                                                <td style={{ width: '140px' }}>
                                                    <div className="d-flex justify-content-center">
                                                        <Dropdown>
                                                            <Dropdown.Toggle size="sm" variant="primary" id="dropdown-basic" className="w-100">
                                                                Actions
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                              {(levelAccess.includes("Level:update") || email === "contact@xpansecafe.com") && (
                                                                <Dropdown.Item onClick={() => handleOpenEditModal(level)}>Edit</Dropdown.Item>
                                                              )}
                                                              {(levelAccess.includes("Level:delete") || email === "contact@xpansecafe.com") && (
                                                                <Dropdown.Item onClick={() => handleOpenDeleteModal(level)}>Delete</Dropdown.Item>
                                                              )}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </td>
                                              )}
                                          </tr>
                                      )
                                  ) }
                              </tbody>
                      </Table>
                  </Row>

                </div>

                {/* <-------------- Add Level Modal ---------------> */}
                <Modal show={addNewOpenModal} onHide={handleCloseAddModal} size='md' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>ADD NEW LEVEL</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={addLevel}>
                        <Modal.Body>
                            <Row className='mb-3'>
                                <Form.Group controlId="formCategoryName">
                                    <Form.Label className='fw-semibold'>Title <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        name="title"
                                        className="form-control"
                                        value={inputData?.title}
                                        type="text"
                                        placeholder="Enter Title"
                                        onChange={handleChange}
                                    />
                                    {/* {errors.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors.title}</div>} */}
                                </Form.Group>
                            </Row>
                            <Row className='mb-3'>
                                <Col md="6">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>Sequence No <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            name="sequenceNo"
                                            className="form-control"
                                            value={inputData?.sequenceNo}
                                            type="number"
                                            placeholder="Enter Sequence Number"
                                            onChange={handleChange}
                                        />
                                        {/* {errors.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors.title}</div>} */}
                                    </Form.Group>
                                </Col>
                                <Col md="6">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>Points Earning Percent <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            name="pointsEarningPercent"
                                            className="form-control"
                                            value={inputData?.pointsEarningPercent}
                                            type="number"
                                            placeholder="Enter Points Earning Percent"
                                            onChange={handleChange}
                                        />
                                        {/* {errors.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors.title}</div>} */}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col md="6">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>Booster Percent</Form.Label>
                                        <Form.Control
                                            name="boosterPercent"
                                            className="form-control"
                                            value={inputData?.boosterPercent}
                                            type="number"
                                            placeholder="Enter Booster Percent"
                                            onChange={handleChange}
                                        />
                                        {/* {errors.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors.title}</div>} */}
                                    </Form.Group>
                                </Col>
                                <Col md="6">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>Required Points <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            name="requiredPoints"
                                            className="form-control"
                                            value={inputData?.requiredPoints}
                                            type="number"
                                            placeholder="Enter Required Points"
                                            onChange={handleChange}
                                        />
                                        {/* {errors.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors.title}</div>} */}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col>
                                    <Form.Label className='fw-semibold'>Choose Image <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        type='file'
                                        id='imageInput'
                                        accept='image/*'
                                        placeholder="Choose Banner Image"
                                        className="form-control"
                                        onChange={handleBannerImageChange}
                                    />
                                    <span className="text-danger mt-3" style={{ fontSize: '11px' }}>choose an image with dimensions equal to 1920x1080</span>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="primary"
                                type='submit'
                            >
                                { isLoading ? 
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                : "Add New Level" }
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* <-------------- Edit Level Modal -------------> */}
                <Modal show={openEditModal} onHide={handleCloseEditModal} size='md' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Level</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={handleEditSubmit}>
                        <Modal.Body>
                            <Row className='mb-3'>
                                <Form.Group controlId="formCategoryName">
                                    <Form.Label className='fw-semibold'>Title <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control
                                        name="name"
                                        className="form-control"
                                        value={editedData?.title}
                                        type="text"
                                        placeholder="Enter Title"
                                        onChange={handleEditChange}
                                    />
                                </Form.Group>
                            </Row>
                            <Row className='mb-3'>
                                <Col md="6">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>Sequence No <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            name="name"
                                            className="form-control"
                                            value={editedData?.sequenceNo}
                                            type="number"
                                            placeholder="Enter Sequence Number"
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md="6">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>Points Earning Percent <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            name="name"
                                            className="form-control"
                                            value={editedData?.pointsEarningPercent}
                                            type="number"
                                            placeholder="Enter Points Earning Percent"
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col md="6">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>Booster Percent</Form.Label>
                                        <Form.Control
                                            name="name"
                                            className="form-control"
                                            value={editedData?.boosterPercent}
                                            type="number"
                                            placeholder="Enter Booster Percent"
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md="6">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>Required Points <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            name="name"
                                            className="form-control"
                                            value={editedData?.requiredPoints}
                                            type="number"
                                            placeholder="Enter Required Points"
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="primary"
                                type='submit'
                            >
                                { isEditBtnLoading ? 
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                : "Update Changes" }
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* <------------- Delete Level Modal ------------> */}
                <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className='text-danger'>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this Level? This action cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={handleDeleteLevel}>
                            { isDeleteBtnLoading ?
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> :
                                "Delete Category"                                
                            }
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default Level